import {VirtualTeamsConstant as constants} from '../../../_constants/VirtualTeams/VirtualTeams.constants';

const initialState = { team_del_loading : true, team_del_data: {}, team_del_error: false };

export function virtualTeamDelete(state = initialState, action) {
   
    switch (action.type) {
        case constants.VIRTUAL_TEAM_DELETE_LOADING:
            return {
                team_del_loading: true,
                team_del_data: {},
                team_del_error: false
            };
        case constants.VIRTUAL_TEAM_DELETE_DATA:
            return {
                team_del_loading: false,
                team_del_data: action.virtual_team_change,
                team_del_error: false
            };
        case constants.VIRTUAL_TEAM_DELETE_ERROR:
            return {
                team_del_loading: false,
                team_del_data: {},
                team_del_error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/VirtualTeams/VirtualTeamDelete/VirtualTeamDelete.reducer.js